<template>
    <!-- 对话框 -->
    <el-drawer title="添加优惠券礼包" :visible.sync="show" :with-header="false" append-to-body :before-close="closeDialog" size="60%">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 80vh;">


                <div style="display: flex;">


                    <el-form-item label="开启状态:" label-width='150px'>


                        <el-switch
                                v-model="submit_data.status"
                                active-value="1"
                                inactive-value="0"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>

                    </el-form-item>

                </div>
                <div>
                     <el-form-item label="仅限新客户:" label-width='150px'>


                        <el-switch
                                v-model="submit_data.is_new"
                                active-value="1"
                                inactive-value="0"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>

                    </el-form-item>

                </div>

                <div style="display: flex;">


                    <el-form-item label="渠道合作商名称:" label-width='150px'>

                        <el-input v-model="submit_data.name" style="width: 150px;margin-right: 5px;" disabled></el-input>

                    </el-form-item>

                </div>

                <div style="display: flex;">


                    <el-form-item label="发放数量:" label-width='150px'>

                        <el-input v-model="submit_data.number" style="width: 150px;margin-right: 5px;" disabled></el-input>

                    </el-form-item>

                </div>

                <div style="display: flex;">


                    <el-form-item label="有效期:" label-width='150px'>

                        <el-date-picker v-model="search_time" type="daterange" range-separator="-" start-placeholder="开始日期"
                                        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="timeChange"
                                        style="width: 250px;" disabled>
                        </el-date-picker>

                    </el-form-item>

                </div>


                <div style="display: flex;">


                    <el-form-item label="关联优惠券:" label-width='150px'>

                        <el-button type="text" @click="children_isShow=!children_isShow" disabled>{{tableData.length==0?'添加':'编辑'}}</el-button>

                    </el-form-item>

                </div>

                <!-- 表格 -->
                <el-table v-if="tableData.length!=0" :data="tableData" style="width: 100%" height="50vh" ref="multipleTable"
                          header-cell-class-name="table-header">






                    <el-table-column prop="name" label="优惠券名称">
                    </el-table-column>

                    <el-table-column prop="num" label="发放数量">
                    </el-table-column>

                    <el-table-column prop="quantity" label="当前剩余">
                    </el-table-column>

                    <el-table-column label="失效时间" prop="end_time.Ymd">
                    </el-table-column>







                </el-table>






            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex;justify-content: center">
                <el-button type="primary" v-if="loading" icon="el-icon-loading"></el-button>
                <el-button @click="sendSubmit" type="primary" v-else>保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

        <couponList :isShow="children_isShow" @onSubmit="getChildrenData"></couponList>

    </el-drawer>
</template>

<script>
    var _this;
    import bus from '@/components/common/bus.js';
    import couponList from './couponList.vue';
    export default {
        components:{
            couponList
        },
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

                _this.submit_data.package_code = _this.data;
                //获取详情接口
                _this.$post('/package/getPackageDetails', {
                    package_code:_this.data
                }).then((res) => {

                    _this.submit_data.status = res.data.status.val;
                    _this.submit_data.is_new = res.data.is_new;

                    _this.submit_data.name = res.data.name;

                    _this.submit_data.number = res.data.number;

                    _this.submit_data.start_time = res.data.start_time.Ymd;

                    _this.submit_data.end_time = res.data.end_time.Ymd;

                    _this.tableData = res.data.order_mode_code_array;

                    _this.search_time = [res.data.start_time.Ymd,res.data.end_time.Ymd]


                }).catch((err) => {
                });


            },

        },
        data() {
            return {
                show: false,

                children_isShow:false,

                loading: false,

                tableData: [],


                search_time:[],



                submit_data:{
                    package_code:'',
                    is_new: '',
                    
                    name:'',
                    order_mode_code_array:'',
                    number:'',
                    start_time:'',
                    end_time:'',
                    status:''
                },



            };
        },
        created() {

            _this = this;
            // 接收http.js文件传来的通知
            bus.$on("btnStatus", (msg) => {
                this.loading = msg;
            });

        },
        methods: {

            getChildrenData(data){

                _this.tableData = data;

            },

            timeChange(val) {
                console.log(val);
                if(val !== null){
                    _this.submit_data.start_time = val[0];
                    _this.submit_data.end_time = val[1];
                }else{
                    _this.submit_data.start_time = '';
                    _this.submit_data.end_time = '';
                }

            },

            sendSubmit() {

                _this.loading = true;
                let synchronization_data = [];

                // 遍历tableData数组
                for (var i = 0; i < _this.tableData.length; i++) {



                    synchronization_data.push({
                        coupon_mode_code: _this.tableData[i].coupon_mode_code,
                        num: _this.tableData[i].num
                    });

                    _this.submit_data.order_mode_code_array = JSON.stringify(synchronization_data)


                }

                console.log(_this.submit_data);



                _this.$post(
                    '/package/editpackage',
                    _this.submit_data
                )
                    .then(res => {

                        _this.$message.success(res.msg);
                        _this.loading = false;
                        _this.closeDialog();

                        _this.$emit('onSubmit')


                    }).catch((err) => {

                });





            },


            // 关闭方法
            closeDialog() {

                _this.show = false;

                _this.submit_data = {
                    package_code:'',
                    is_new: '',

                    name:'',
                    order_mode_code_array:'',
                    number:'',
                    start_time:'',
                    end_time:'',
                    status:''
                };


                _this.search_time = '';
                _this.tableData = [];


            }


        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>
